import angular from 'angular';
import subscriptionSuccess from './subscriptionSuccess';

export default angular
  .module('component.subscriptionSuccess', [])
  .component('subscriptionSuccess', subscriptionSuccess).name;
